import { getMultipleLotteryResultRequest, getMultipleLotteryCountRequest, getLotteryTopRecordRequest } from 'lib/apis';
import { AWARD_PRIZE_TYPE } from 'lib/constants/award';
import monitor from 'lib/utils/monitor';
import toast from 'lib/utils/toast';
import { COMMON_MSG } from 'lib/constants/error';
import { create } from 'zustand';

interface LotteryPrizeStore {
  lotteryActId: number;
  receivedPrizes: Array<Record<string, any>>;
  setLotteryActId: (actId: number) => void;
  queryLotteryPrizeResult: () => void;
  queryPrizesByGameCodeResult: () => void;
  remainLotteryCount: number;
  queryRemainLotteryCount: () => void;
  currentReceivedPrizes: Array<Record<string, any>>;
  topReceivedPrizes: Array<Record<string, any>>;
  setCurrentReceivedPrizes: (prizeList: Array<Record<string, any>>) => void;
}

const filterCurrentPrizeList = (allPrizeList, currentPrizeList) => allPrizeList.filter(item => currentPrizeList.some(currentItem => currentItem.id === item.id));
function sortPrizeList(prizeList: Array<Record<string, any>>) {
  // 抽奖接口和抽奖记录接口返回的顺序不一致，所以先按id排序，然后把外链奖品排在前面,两个排序分开更好理解
  return prizeList
    .sort((a, b) => {
      if (a.id > b.id) {
        return 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      return 0;
    })
    .sort((a, b) => {
      if (a.prizeType === AWARD_PRIZE_TYPE.OUTER_LINK) {
        return -1;
      }
      if (b.prizeType === AWARD_PRIZE_TYPE.OUTER_LINK) {
        return 1;
      }
      return 0;
    });
}

export const useLotteryPrizeStore = create<LotteryPrizeStore>((set, get) => ({
  receivedPrizes: [], // 多次抽奖结果
  topReceivedPrizes: [],
  lotteryActId: 0,
  remainLotteryCount: -1,
  currentReceivedPrizes: [], // 当前抽奖结果
  setLotteryActId: (actId) => {
    set(state => ({
      ...state,
      lotteryActId: actId,
    }));
  },
  queryLotteryPrizeResult: async () => {
    const actId = get().lotteryActId;
    const res = await getMultipleLotteryResultRequest({
      actId: +actId,
    });
    const handleErr = () => {
      toast.info(COMMON_MSG);
      set(state => ({
        ...state,
        receivedPrizes: [],
      }));
      return;
    };

    if (res?.code !== 0) {
      monitor.reportLog({
        actionName: 'lottery result query failed',
      });
      handleErr();
      return;
    }

    set(state => ({
      ...state,
      receivedPrizes: sortPrizeList(res.data?.drawResult || []),
      currentReceivedPrizes: sortPrizeList(filterCurrentPrizeList(
        res.data?.drawResult || [],
        state.currentReceivedPrizes
      )),
    }));
    return;
  },
  queryPrizesByGameCodeResult: async () => {
    const res = await getLotteryTopRecordRequest();
    const handleErr = () => {
      toast.info(COMMON_MSG);
      set(state => ({
        ...state,
        topReceivedPrizes: [],
      }));
      return;
    };

    if (res?.code !== 0) {
      monitor.reportLog({
        actionName: 'lottery record swiper query failed ',
      });
      handleErr();
      return;
    }

    set(state => ({
      ...state,
      topReceivedPrizes: res.data?.prizes || [],
    }));
    return;
  },
  // 当前抽奖结果
  setCurrentReceivedPrizes: (prizeList) => {
    // 如果有奖品但是奖品数量不为10个，说明抽奖结果异常
    if (prizeList?.length !== 10) {
      monitor.reportLog({
        actionName: 'lottery result count error',
      });
    }
    set(state => ({
      ...state,
      currentReceivedPrizes: sortPrizeList(prizeList),
    }));
  },
  queryRemainLotteryCount: async () => {
    const actId = get().lotteryActId;
    const res = await getMultipleLotteryCountRequest({ actId: +actId });

    const handleErr = () => {
      toast.info(COMMON_MSG);
      set(state => ({
        ...state,
        remainLotteryCount: -1,
      }));
      return;
    };

    if (res?.code !== 0) {
      monitor.reportLog({
        actionName: 'lottery count error',
      });
      handleErr();
      return;
    }

    set(state => ({
      ...state,
      remainLotteryCount: res.data?.remainingCount || 0,
    }));
    return;
  },
}));

